import {Component, OnInit} from '@angular/core';

declare var Parallax: any;

@Component({
  selector: 'nine-reason',
  templateUrl: './nine-reason.component.html',
  styleUrls: ['./nine-reason.component.sass']
})
export class NineReasonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const nineReasonScene = document.getElementById('nine-reason__scene');
    const parallax = new Parallax(nineReasonScene, {
      pointerEvents: true,
      relativeInput: true,
      limitY: 0,
      invertY: false,
      invertX: false,
      selector: '.nine-reason__img',
    });
  }

}
